import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Elastic, Power0, TimelineLite, TimelineMax, TweenLite} from "gsap";
import {TeslaGameAssets} from "../../TeslaGameAssets";

/**
 * Created by h3 on 2017-09-28.
 */

export class TeslaGaugeView extends PIXI.Container {
    private _gaugePin:PIXI.Sprite;
    private _gaugeCracked:PIXI.Sprite;
    private _defaultRotation:number = -30 * PIXI.DEG_TO_RAD;
    private _gaugeCrackedTween:TimelineSprite;
    private _gaugeLight:PIXI.Sprite;
    private _gaugeLightEffect:PIXI.Sprite;
    private _nearWinGaugeTimeline:TimelineMax;

    constructor() {
        super();
        this.initAnimations();
    }

    protected initAnimations():void {
        this._gaugeCracked = new PIXI.Sprite(GameResources.getTextures(TeslaGameAssets.GAUGE_CRACKED)[0]);
        this._gaugeCracked.anchor.set(0.5, 0.5);

        this._gaugePin = new PIXI.Sprite(GameResources.getTextures(TeslaGameAssets.GAUGE_PIN)[0]);
        this._gaugePin.anchor.set(0.84, 0.84);

        this._gaugeLight = new PIXI.Sprite(GameResources.getTextures(TeslaGameAssets.GAUGE_LIGHT)[0]);
        this._gaugeLight.scale.set(0.6, 0.6);
        this._gaugeLight.anchor.set(0.5, 0.5);

        this._gaugeLightEffect = new PIXI.Sprite(GameResources.getTextures(TeslaGameAssets.GAUGE_LIGHT_EFFECT)[0]);
        this._gaugeLightEffect.scale.set(0.6, 0.6);
        this._gaugeLightEffect.anchor.set(0.5, 0.5);

        this._gaugeCrackedTween = new TimelineSprite(GameResources.getTextures(TeslaGameAssets.GAUGE_CRACK_ANIMATION));
        this._gaugeCrackedTween.anchor.set(0.5, 0.5);

        this.addChild(this._gaugeCracked);
        this.addChild(this._gaugePin);
        this.addChild(this._gaugeLight);
        this.addChild(this._gaugeLightEffect);
        this.addChild(this._gaugeCrackedTween);

        this.resetView(false);
    }

    public onResize(data:IResizeData):void {
        this._gaugeCracked.position.set(0, 0);
        this._gaugePin.position.set(9, 18);
        this._gaugeLight.position.set(9, 16);
        this._gaugeLightEffect.position.set(9, 16);
        this._gaugeCrackedTween.position.set(9, 60);
    }

    public getNearWinGaugeAnimation(reelId:number) {
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => this.blinkingLightEffect());
        if(reelId === 1) {
            tl.add(this.getGaugePinRotation(0));
        } else if(reelId === 2) {
            tl.add(this.getGaugePinRotation(22));
        } else if(reelId === 3) {
            tl.add(this.getGaugePinRotation(42));
        }


    }

    public resetNearWinGaugeAnimation(getCracked:boolean = true) {
        if(this._nearWinGaugeTimeline) {
            this._nearWinGaugeTimeline.kill();
        }

        const tl:TimelineLite = new TimelineLite();
        if(getCracked === true) {
            tl.add(this.getCrackedAnimation());
        }

        tl.add(() => this.resetView(true));


    }

    private blinkingLightEffect():void {
        this._nearWinGaugeTimeline = new TimelineMax({repeat : -1});
        this._nearWinGaugeTimeline.add([
            new TweenLite(this._gaugeLight, 0.4, {alpha : 1}),
            new TweenLite(this._gaugeLightEffect, 0.4, {alpha : 1}),
        ]);
        this._nearWinGaugeTimeline.add([
            new TweenLite(this._gaugeLight, 0.4, {alpha : 0}),
            new TweenLite(this._gaugeLightEffect, 0.4, {alpha : 0}),
        ]);
    }

    private getGaugeAnimation(betLineWinData:IBetLineWinData, betValue:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        let amount = betLineWinData.amount;
        let ratio = amount / betValue;

        if(ratio < 1.5) {
            tl.add(() => this.getGaugePinRotation(0));
        } else if(ratio >= 1.5 && ratio < 3) {
            tl.add(() => this.getGaugePinRotation(22));
        } else if(ratio >= 3 && ratio < 5) {
            tl.add(() => this.getGaugePinRotation(42));
        } else {
            tl.add([
                new TweenLite(this._gaugeLight, 0.2, {alpha : 1}),
                new TweenLite(this._gaugeLightEffect, 0.2, {alpha : 1}),
                () => this.getGaugePinRotation(60),
                () => this.getCrackedAnimation()
            ]);
            tl.add([
                new TweenLite(this._gaugeLight, 0.2, {alpha : 0}),
                new TweenLite(this._gaugeLightEffect, 0.2, {alpha : 0}),
            ]);
        }

        tl.add(() => this.resetGaugePinRotation());

        return tl;
    }

    private getCrackedAnimation():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add([
            new TweenLite(this._gaugeCracked, 0.05, {alpha : 1}),
            this._gaugeCrackedTween.getAnimationAutoShowHide(true, true)
        ]);

        return tl;
    }

    private resetGaugePinRotation():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(TweenLite.to(this._gaugePin, 0.3, {ease : Power0.easeNone, rotation : this._defaultRotation}));
        return tl;
    }

    private getGaugePinRotation(rotateTo:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        let rotationAngle = rotateTo * PIXI.DEG_TO_RAD;
        tl.add(TweenLite.to(this._gaugePin, 0.5, {ease : Elastic.easeOut.config(2.5, 0.4), rotation : rotationAngle}));
        return tl;
    }

    public resetView(animated:boolean = true) {

        if(this._nearWinGaugeTimeline) {
            this._nearWinGaugeTimeline.kill();
        }

        if(animated) {
            new TweenLite(this._gaugeCracked, 0.5, {alpha : 0});
        } else {
            this._gaugeCracked.alpha = 0;
        }
        new TweenLite(this._gaugePin, 0.5, {rotation : this._defaultRotation});
        this._gaugeLight.alpha = 0;
        this._gaugeLightEffect.alpha = 0;
        this._gaugeCrackedTween.hide();
    }

    public getGaugeAnimations(betWinsData:IBetLineWinData[], betValue:number):TimelineLite[] {
        let gaugeAnimations:TimelineLite[] = [];
        for(let i:number = 0; i < betWinsData.length; i++) {
            let betLineWinData:IBetLineWinData = betWinsData[i];
            gaugeAnimations.push(this.getGaugeAnimation(betLineWinData, betValue));
        }
        return gaugeAnimations;
    }
}

